<template>
  <section
     class="bg-center mt-[40px] before:z-10 pb-10 max-md:bg-bottom md:bg-center bg-cover bg-no-repeat bg-size-[100%] min-h-[346px] h-full w-full relative before:content-[''] before:block before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-[#5f4ca4] before:opacity-75"
  >
  <img 
    :src="data?.image" 
    :alt="data?.heading"
    class="absolute inset-0 w-full h-full object-cover object-center z-0"
    fetchpriority="high"
  >
    <div class="max-w-screen-xl px-4 relative z-30 mx-auto text-center text-wrap">

      
      <h1
        class="xl:text-[57px] text-[37px] leading-[1.125] text-white text-center font-bold pt-28 text-wrap"
        v-html="data?.heading"
      >
      </h1>
      <p class="text-lg text-center text-white my-4" v-html="data?.text">
      </p>
      <button
        class="bg-transparent border border-[#fff] text-[#fff] py-2 px-4 rounded-md hover:bg-[linear-gradient(to_right_bottom,_#243ea1,_#283aa2,_#2d36a3,_#3231a3,_#372ca3,_#3f2ba4,_#462aa6,_#4d28a7,_#572baa,_#602eae,_#6932b1,_#7235b4)] hover:border-none"
        @click="openModal"
      >
        Get a Quote
      </button>
    </div>
  </section>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: {
    heading: string;
    subheading: string;
    flipcontent: string;
    image_safari_ext: string;
    image: string;
    text: string;
    link: {
      srclink: string;
      label: string;
    };
  };
}>();
const emit = defineEmits<{
  (event: "openModal"): void;
}>();

function openModal() {
  emit("openModal");
}
useHead({
  link: [
    {
      rel: "preload",
      as: "image",
      href: props.data?.image,
      fetchpriority: "high",
    },
  ],
});
</script>

<style lang="scss" scoped></style>
